import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H3 } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled from 'styled-components';

import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogLotsListed,
    getTimedPlusCatalogClosedLotCount,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';

export type CatalogStatusBarProps = {
    catalogId: number;
    className?: string;
};

const CatalogStatusBar = ({ catalogId, className }: CatalogStatusBarProps) => {
    const total = useAppSelector((state) => getCatalogLotsListed(state, catalogId)) || 100;
    const closedLotsCount = useAppSelector((state) => getTimedPlusCatalogClosedLotCount(state, catalogId));
    const percentage = total ? Math.round((closedLotsCount / total) * 100) : 0;

    return (
        <StyledCatalogStatusBar
            className={className}
            data-testid="catalog-status-bar"
        >
            <StyledLotProgress as="h3">
                <FormattedMessage
                    id="catalogPage.catalogStatus.progressStatus"
                    values={{
                        current: closedLotsCount,
                        total,
                    }}
                />
            </StyledLotProgress>
            <PercentageMeter>
                <Progress
                    data-testid="catalog-status-bar-progress"
                    percentage={percentage}
                />
            </PercentageMeter>
        </StyledCatalogStatusBar>
    );
};

export default CatalogStatusBar;

const StyledCatalogStatusBar = styled.div`
    display: block;
    width: 100%;
    text-align: center;
`;

const StyledLotProgress = styled(H3)`
    margin: 16px 0;
`;

const PercentageMeter = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    flex: 1 1 auto;
    height: 8px;
    width: 100%;
    margin-bottom: 32px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.grey400};
    overflow: hidden;
`;

const Progress = styled.div<{ percentage: number }>`
    background-color: ${({ theme }) => theme.colors.blue100};
    height: 100%;
    width: ${({ percentage }) => `${Math.max(percentage, 2.5)}%`};
    transition: all 0.25s;
    border-radius: 8px;
`;
